import {MAX_FILE_SIZE} from "../ui/containers/App/constants";

export const checkFileType = file => {
    if(!file) return;
    if(file && file.name && typeof file.name==="string")
    {
        let fileType = file.name.split('.').pop();
        return (
            fileType !== "jpg" &&
            fileType !== "jpeg" &&
            fileType !== "pdf" &&
            fileType !== "txt" &&
            fileType !== "ppt" &&
            fileType !== "docx" &&
            fileType !== "mp4" &&
            fileType !== "gif" &&
            fileType !== "png" &&
            fileType !== "mov"
        );
    }
    return false
}

export const fileValidate = (file, Language) => {
    if(checkFileType(file)){
        return Language ? Language.FileTypeNotSupported : 'Error: File type is not supported';
    }
    if(file.size > MAX_FILE_SIZE){
        return Language ? Language.FileSizeExceedsLimit : 'Error: File size exceeds 10Mb.';
    }
    return '';
}